import { Component } from '@angular/core';

@Component({
    selector: 'app-dc-spinner',
    templateUrl: './dc-spinner.component.html',
    styleUrls: ['./dc-spinner.component.scss']
})
export class DcSpinnerComponent {

    constructor() { }

}